
$controllers.upgrade = {
	
	onUnload : function() {
		$controllers.all.unbindEnterFormSubmissions();
	},
	
	display : function() {
		
		if (!$controllers.all.enforcePagePermissions('upgrade')) { return false; }
		$controllers.all.showPage('upgrade', 'contentpage');
		$controllers.all.setNavigation();
		$views.upgrade.display();
		$controllers.all.handleEnterFormSubmissions();
		
	},
	
	process : function() {
		
		// quick validation
		//if (!$models.profilesettings.validateFormData()) {
		//	return false;
		//}
		
		var $form = jQuery('form.pin'),
		$submitButton = $form.find(":submit");
		
		// disable the submit button to prevent multiple clicks
		$submitButton.attr({disabled: true});
		
		// fetch details required for the createToken call to Pin
		var card = {
			number: jQuery('#cc-number').val(),
			name: jQuery('#cc-name').val(),
			expiry_month: jQuery('#cc-expiry-month').val(),
			expiry_year: jQuery('#cc-expiry-year').val(),
			cvc: jQuery('#cc-cvc').val(),
			address_line1: jQuery('#address-line1').val(),
			address_line2: jQuery('#address-line2').val(),
			address_city: jQuery('#address-city').val(),
			address_state: jQuery('#address-state').val(),
			address_postcode: jQuery('#address-postcode').val(),
			address_country: jQuery('#address-country').val()
		};
		console.log(card);
		// call Pin.js to request a card token and submit it to the server
		Pin.createToken(card, $controllers.upgrade.handleResponse);
		
	},
	
	handleResponse : function(response) {
		
		var $form = jQuery('form.pin'),
		$submitButton = $form.find(':submit');
		
		if (response.response) {
			
			// Add the card token and ip address of the customer to the form
			// You will need to post these to Pin when creating the charge.
			jQuery('<input>')
				.attr({type: 'hidden', name: 'card_token'})
				.val(response.response.token)
				.appendTo($form);
			jQuery('<input>')
				.attr({type: 'hidden', name: 'ip_address'})
				.val(response.ip_address)
				.appendTo($form);
			
			// now charge the credit card
			$controllers.upgrade.chargeCreditCard(response);
			
			$soupmail.notification.message('Token has been retrieved: '+response.response.token + ' of '+response.ip_address);
			
		} else {
			
			$soupmail.notification.error(response.error_description);
			
			if (response.messages) {
				jQuery.each(response.messages, function(index, errorMessage) {
					jQuery('<li>')
					.text(errorMessage.param + ": " + errorMessage.message)
					.appendTo($errorList);
				});
			}
			
			$submitButton.removeAttr('disabled');
			
		}
		
	},
	
	chargeCreditCard : function(response) {
		
		jQuery.getJSON('http://soupmail.dev.smartmultimedia.com.au/templates/soupmail/temporary-payment-api.php', {email:$models.login.getEmailAddress(), token:response.response.token}, function(data) {
			
			if (data.response) {
				$soupmail.modal.message(data.response.status_message);
			} else {
				$soupmail.notification.error(data.error_description);
				$submitButton.removeAttr('disabled');
			}
			
		});
		
	}
	
};



// WEBPACK FOOTER //
// ./src/js/controllers/desktop.upgrade.js